module.exports = __webpack_public_path__ + "img/hartg.ecf13070.jpg";